import { AppBundle } from 'api/optimalprint-sdk.d';
import { AppDispatch, Store } from 'store';
import getLocaleSelector from 'store/app/selector/getLocaleSelector';
import getLastOrderItemId from 'store/product/selector/getLastOrderItemId';
import getProductItem from 'store/product/selector/getProductItem';
import getProductType from 'store/product/selector/getProductType';
import { ProductType } from 'store/product/types';
import gtmAddToCartEvent from 'utils/gtm/gtmAddToCartEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmAddToCartGa4Event from 'utils/gtm/gtmAddToCartGa4Event';
import getCurrentProductPrice from 'store/product/selector/getCurrentProductPrice';
import getProductQuantity from 'store/product/selector/getProductQuantity';
import getCurrencyId from 'store/price/selector/getCurrencyId';
import getGtmProductsData from '../selector/getGtmProductsData';

const sendGtmAddToCartOperation = () => (dispatch: AppDispatch, getState: () => Store) => {
  const store = getState();
  const lastOrderItemId = getLastOrderItemId(store);
  const locale = getLocaleSelector(store);
  const quantity = getProductQuantity(store);
  const currentProductPrice = getCurrentProductPrice(store);
  const currencyId = getCurrencyId(store) || 'NOK';

  const productType = getProductType(store);
  if (productType !== ProductType.predesigned) return;

  const item = getProductItem(store) as AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem;
  const { encDesignId } = item;
  if (!encDesignId || !lastOrderItemId) return;

  const gtmProductsData = getGtmProductsData(store);
  const gtmProductData = gtmProductsData[encDesignId];
  if (!gtmProductData) return;

  gtmSendEvent(gtmAddToCartEvent(gtmProductData, lastOrderItemId, encDesignId, locale));

  if (!currencyId || !currentProductPrice) return;
  gtmSendEvent(
    gtmAddToCartGa4Event(
      gtmProductData,
      lastOrderItemId,
      currencyId,
      currentProductPrice.regularPrice,
      quantity,
      currentProductPrice.discountedPrice,
    ),
  );
};

export default sendGtmAddToCartOperation;
